<template>
	<div class="container__registers">
		<ContentHeader>
			<SubHeader :title="title" />
		</ContentHeader>
		<ContentBody>
			<Card>
				<router-view />
			</Card>
		</ContentBody>
	</div>
</template>

<script>
import Card from '../../components/Card/Card'
import ContentBody from '../../components/ContentBody/ContentBody'
import ContentHeader from '../../components/ContentHeader/ContentHeader'
import SubHeader from '../../components/SubHeader/SubHeader'

export default {
	components: { Card, ContentBody, ContentHeader, SubHeader },
	data() {
		return {
			activeRoute: '',
			labelAndLinkName: [
				{
					label: this.$t('treeInventory'),
					linkName: 'exportacaoinventarioarvore',
				},
				// {
				//   label: this.$t("plotInventory"),
				//   linkName: "exportarinventarioparcela",
				// },
				{
					label: this.$t('sectionInventory'),
					linkName: 'exportacaoinventariotalhao',
				},
				{
					label: this.$t('stratumInventory'),
					linkName: 'exportacaoinventarioestrato',
				},
				{
					label: this.$t('stackInventory'),
					linkName: 'exportacaoinventariopilha',
				},
				{
					label: this.$t('exportPrognosisProjection'),
					linkName: 'exportacaovinculaprognose',
				},
				{
					label: this.$t('singleTreesInventory'),
					linkName: 'exportacaoinventariosingletrees',
				},
				{
					label: this.$t('exportBetas'),
					linkName: 'exportacaobetas',
				},
				{
					label: this.$t('compiledInventory'),
					linkName: 'inventariocompilado',
				},

				{
					label: this.$t('qualityInventory'),
					linkName: 'inventarioqualidadexportacao',
				},

				{
					label: this.$t('climateData'),
					linkName: 'exportacaodadosclimaticos',
				},
			],
		}
	},
	computed: {
		title() {
			return `${this.$t('exports')} / ${this.label}`
		},
		label() {
			return this.labelAndLinkName.find((f) => f.linkName === this.activeRoute).label
		},
	},
	watch: {
		$route(to) {
			this.activeRoute = to.name
		},
	},
	created() {
		this.activeRoute = this.$route.name
	},
}
</script>
